import React, { useEffect, useState } from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

function GraficoRadar({ labels, data }) {
  const [dados, setDados] = useState({
    labels: [],
    datasets: [
      {
        label: "Avaliações",
        data: [],
        fill: true,
        backgroundColor: "rgba(0, 140, 255, 0.46)",
        borderColor: "rgb(54, 162, 235)",
        pointBackgroundColor: "rgb(54, 162, 235)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgb(54, 162, 235)",
      },
    ],
  });

  useEffect(() => {
    setDados({
      labels: labels,
      datasets: [
        {
          ...dados.datasets[0],
          data: data,
        },
      ],
    });
  }, [labels, data]);

  const options = {
    plugins: {
      legend: {
        display: false, // Isso esconde a legenda
      },
    },
    scales: {
      r: {
        min: 0,
        max: 4,
        ticks: {
          stepSize: 1,
        },
      },
    },
  };


  return (
    <div>
      <Radar data={dados} options={options} />
    </div>
  );
}

export default GraficoRadar;